import axios from 'axios';
import router from '@/router';

// axios.defaults.baseURL = 'http://localhost:3068/api';
axios.defaults.baseURL = 'https://shop.sheetvn.com/api';

// Request interceptor để thêm token vào mỗi request
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor để xử lý lỗi 401
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Clear token và redirect về login
      localStorage.removeItem('token');
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

export default axios;